module.exports = __webpack_public_path__ + "static/media/realtor-3.17578cdf.jpeg";